import React from 'react'
import logo from '../assets/images/aluk.svg'
import novaeLogo from '../assets/images/novae-black.png'

const AluKHeader = () => (
  <header className='App-logo'>
    <img src={logo} alt='AluK' />
    <img id='novae-logo' src={novaeLogo} alt='NOVAE - Quadra • Rondo' />
  </header>
)

export default AluKHeader



// WEBPACK FOOTER //
// ./src/components/AluKHeader.js